<template>
  <div class="base-card" @click="handleClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'base-card',

  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style></style>
